<template>
    <div class="app-image"
         :style="intristicRatioStyle"
         v-observe-visibility="{
          callback: lazyLoadImage,
          throttle: 250,
          once: true
         }"
    >
        <img class="app-image__image"
             ref="img"
             v-if="show"
             :src="src"/>
    </div>
</template>

<script>
    export default {
        name: "AppImage",
        props: {
            ratio: {
                type: String,
                default: ''
            },
            src: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                show: false,
                loaded: false
            }
        },
        computed: {
            intristicRatio() {
                if (!this.ratio) {
                    return 0
                } else {
                    const sizes = this.ratio.split(':')
                    const ratio = sizes[1] / sizes[0]
                    return ratio
                }
            },
            intristicRatioStyle() {
                return {
                    'padding-bottom': `${this.intristicRatio * 100}%`
                }
            }
        },
        methods: {
            lazyLoadImage(isVisible) {
                if (isVisible) {
                    this.show = true
                    this.$nextTick(() => {
                        const lazyImage = this.$refs.img

                        lazyImage.addEventListener('load', () => {
                            this.$nextTick(() => {
                                lazyImage.classList.add('lazy-loaded')
                                this.loaded = true
                            })
                        })
                        lazyImage.addEventListener('error', () => {
                            lazyImage.classList.add('lazy-load-error')
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-image {
        position: relative;
        overflow: hidden;
        background-color: $componentBackgroundColor;
        background-color: var(--componentBackgroundColor);
        @include transition-colors;

        &__image {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: auto;
            opacity: 0;
            transition: opacity .5s;

            &.lazy-loaded {
                opacity: 1;
            }
        }
    }
</style>